import { ApiGetRequest } from '../../api';

export const state = {
  data: {
    total_in: 0,
    loading_in: false,
    total_out: 0,
    loading_out: false,
    total_empty: 0,
    loading_empty: false,
    chartData: {
      series: [
        {
          name: 'Stock In',
          data: [],
        },
        {
          name: 'Stock Out',
          data: [],
        },
      ],
      chartoptions: {
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        colors: ['#556ee6', '#f1b44c'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },
        markers: {
          size: 3,
          strokeWidth: 3,

          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
        },
      },
    },
  },
};

export const mutations = {
  changeDashboard(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getTotalStockIn({ commit }, payload = null) {
    commit('changeDashboard', {
      [`loading_${payload.status.replace('-', '_')}`]: true,
    });

    let result = await ApiGetRequest(
      `logistic/dashboard/data-${payload.status ? payload.status : 'av'}`
    );

    commit('changeDashboard', {
      [`total_${payload.status.replace('-', '_')}`]: result.error
        ? 0
        : result.data.object,
      [`loading_${payload.status.replace('-', '_')}`]: false,
    });

    return !result.error ? true : false;
  },

  async getTotalStockOut({ commit }, payload = null) {
    commit('changeDashboard', {
      [`loading_${payload.status.replace('-', '_')}`]: true,
    });

    let result = await ApiGetRequest(
      `logistic/dashboard/data-${payload.status ? payload.status : 'av'}`
    );

    commit('changeDashboard', {
      [`total_${payload.status.replace('-', '_')}`]: result.error
        ? 0
        : result.data.object,
      [`loading_${payload.status.replace('-', '_')}`]: false,
    });

    return !result.error ? true : false;
  },

  async getTotalEmptyStock({ commit }, payload = null) {
    commit('changeDashboard', {
      [`loading_${payload.status.replace('-', '_')}`]: true,
    });

    let result = await ApiGetRequest(
      `logistic/dashboard/data-${payload.status ? payload.status : 'av'}`
    );

    commit('changeDashboard', {
      [`total_${payload.status.replace('-', '_')}`]: result.error
        ? 0
        : result.data.object,
      [`loading_${payload.status.replace('-', '_')}`]: false,
    });

    return !result.error ? true : false;
  },

  async getChartDashboard({ commit, state }) {
    commit('changeDashboard', {
      [`loading_chart`]: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/dashboard/data-chart`);
    commit('changeDashboard', {
      chartData: {
        ...data.chartData,
        series: result.data.object,
      },
      [`loading_chart`]: false,
    });

    return !result.error ? true : false;
  },
};
